import { render } from "./ind_ban.vue?vue&type=template&id=5a4ba00e&scoped=true"
import script from "./ind_ban.vue?vue&type=script&lang=js"
export * from "./ind_ban.vue?vue&type=script&lang=js"

import "./ind_ban.vue?vue&type=style&index=0&id=5a4ba00e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4ba00e"]])

export default __exports__